<script lang="ts" setup>
import { useAppStore, useRouteStore } from '@/store'
import {
  BackTop,
  Breadcrumb,
  CollapaseButton,
  Float,
  FullScreen,
  Logo,
  Menu,
  Notices,
  Quick,
  Search,
  Setting,
  TabBar,
  UserCenter,
} from './components'

const routeStore = useRouteStore()

const appStore = useAppStore()

const rightConRef = ref()

provide('rightConRef', rightConRef)

const router = useRouter()
// 因为框架结构问题，只能用这种方法不能使用在路由中使用scrollBehavior
watch(() =>
  router.currentRoute.value.path, (_toPath) => {
  rightConRef.value?.scrollTo({ top: 0, behavior: 'smooth' })
}, { immediate: true, deep: true })
</script>

<template>
  <n-layout
    has-sider
    class="wh-full"
    embedded
  >
    <n-layout-sider
      v-if="!appStore.contentFullScreen"
      :class="[{ 'lt-md:hidden': appStore.collapsed }]"
      bordered
      :collapsed="appStore.collapsed"
      collapse-mode="width"
      :collapsed-width="64"
      :width="240"
      class="z-10"
      content-style="display: flex;flex-direction: column;min-height:100%;"
    >
      <Logo v-if="appStore.showLogo" />
      <n-scrollbar class="flex-1">
        <Menu />
      </n-scrollbar>
    </n-layout-sider>
    <n-layout
      ref="rightConRef"
      class="h-full flex flex-col rightConRef"
      :class="[{ 'flex-shrink-0': !appStore.collapsed && appStore.isMobile }]"
      content-style="display: flex;flex-direction: column;min-height:100%;"
      embedded
      :native-scrollbar="false"
    >
      <n-layout-header bordered position="absolute" class="z-999">
        <div v-if="!appStore.contentFullScreen" class="h-60px flex-y-center justify-between">
          <div class="flex-y-center h-full">
            <CollapaseButton />
            <Breadcrumb />
          </div>
          <div class="flex-y-center gap-1 h-full p-x-xl lt-md:px-4px">
            <Search v-if="!appStore.isMobile" />
            <Quick />
            <Notices />
            <!-- <FullScreen /> -->
            <!-- <DarkModeSwitch /> -->
            <!-- <Setting /> -->
            <UserCenter />
          </div>
        </div>
        <TabBar v-if="appStore.showTabs && !appStore.isMobile" class="h-45px" />
      </n-layout-header>
      <!-- 121 = 16 + 45 + 60 45是面包屑高度 60是标签栏高度 -->
      <!-- 56 = 16 + 40 40是页脚高度 -->
      <div
        class="flex-1 p-16px flex flex-col  lt-md:pt-76px lt-md:px-10px"
        :class="{
          'p-t-121px': appStore.showTabs,
          'p-t-76px': !appStore.showTabs,
          'p-t-61px': appStore.contentFullScreen,
        }"
      >
        <router-view v-slot="{ Component, route }" class="flex-1">
          <transition
            :name="appStore.transitionAnimation"
            mode="out-in"
          >
            <keep-alive :include="routeStore.cacheRoutes" :max="10">
              <component
                :is="Component"
                v-if="appStore.loadFlag && !(!!$route.meta.isIframe)"
                :key="route.fullPath"
              />
            </keep-alive>
          </transition>
        </router-view>
        <iframe-keep-alive />
        <div class="self-content relative">
          <EmailCheck class="email-modal" />
        </div>
      </div>
      <Float v-if="!appStore.isMobile" />
      <BackTop />
    </n-layout>
  </n-layout>
</template>
